import type { StateCreator } from 'zustand'

import type { AppSlice } from '../appSlice'
import type { ChannelSlice } from '../channelSlice'
import type { DirtySlice } from '../dirtySlice'
import type { EditorSlice } from '../editorSlice'
import type { ModeSlice } from '../modeSlice/modeSlice'
import type { PostSlice } from '../postSlice/postSlice'
import type { SaveErrorsSlice } from '../saveErrorsSlice'

export interface MixedMediaCapabilityInputs {
  /** The org-level `mixed-media` Split flag, resolved (false until ready). */
  orgEnabled: boolean
}

export interface CapabilityState {
  /**
   * Raw capability inputs, seeded from React (`useMixedMediaCapabilityBridge`)
   * so non-React legacy code can derive the mixed-media capability via
   * `getMixedMediaCapabilityForService` without a hook.
   */
  mixedMediaCapabilityInputs: MixedMediaCapabilityInputs
}

export interface CapabilityActions {
  setMixedMediaCapabilityInputs: (inputs: MixedMediaCapabilityInputs) => void
}

export type CapabilitySlice = CapabilityState & CapabilityActions

export const createCapabilitySlice: StateCreator<
  AppSlice &
    ChannelSlice &
    DirtySlice &
    EditorSlice &
    ModeSlice &
    PostSlice &
    SaveErrorsSlice &
    CapabilitySlice,
  [['zustand/devtools', never], ['zustand/immer', never]],
  [],
  CapabilitySlice
> = (set) => ({
  mixedMediaCapabilityInputs: { orgEnabled: false },

  setMixedMediaCapabilityInputs: (inputs): void =>
    set(
      (state) => {
        state.mixedMediaCapabilityInputs = inputs
      },
      undefined,
      'capabilitySlice:setMixedMediaCapabilityInputs',
    ),
})
